import { Icon } from '@chakra-ui/react';

const PCVideoIcon = (props) => (
    <Icon
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 30 30"
        fill={'#4A5668'}
        // style="enable-background:new 0 0 1500 1500;"
        {...props}>

        <g>
            <g>
                <path class="st0" d="M28.01,9.72c0-0.73-0.18-0.9-0.92-0.9H10.97c0.53-0.16,1.07-0.25,1.61-0.34c3.87-0.68,7.73-1.37,11.6-2.05
			c0.92-0.16,1.84-0.32,2.76-0.49c0.51-0.09,0.77-0.37,0.7-0.78c-0.21-1.22-0.42-2.44-0.65-3.66c-0.09-0.48-0.38-0.68-0.86-0.59
			c-2.89,0.51-5.79,1.02-8.68,1.54c-3.06,0.54-6.12,1.08-9.18,1.62C6.41,4.39,4.55,4.71,2.7,5.04C2.07,5.15,1.9,5.42,2.02,6.05
			c0.06,0.31,0.12,0.62,0.17,0.93C2.34,8.09,2.6,9.2,2.61,10.3c0.04,5.95,0.02,11.91,0.02,17.87c0,0.75,0.19,0.94,0.93,0.94H25.3
			c0.12,0,0.24,0.01,0.36-0.01c0.35-0.05,0.54-0.25,0.56-0.6c0.02-0.34-0.22-0.61-0.56-0.65c-0.12-0.01-0.24-0.01-0.36-0.01H3.94
			V13.92h22.78v0.42c0,0.65-0.01,8.67,0,9.32c0.01,0.39,0.29,0.68,0.63,0.68c0.35,0.01,0.61-0.26,0.65-0.66
			c0.01-0.08,0.01-7.53,0.01-7.61C28.01,13.95,28.01,11.84,28.01,9.72z M3.81,8.71L3.24,6.21l22.78-4.18l0.51,2.66l-0.72,0.13
			c0,0,0.01,0.01,0.02,0.01c-1.17,0.21-2.24,0.4-3.3,0.59c-0.53,0.09-1.06,0.21-1.6,0.27c-0.01,0-0.02,0-0.02,0l-2.16,0.38
			c0,0,0.01,0.01,0.02,0.01c-0.59,0.1-1.09,0.19-1.59,0.27l-1.96,0.35c0,0,0,0,0,0c-0.62,0.11-1.14,0.21-1.67,0.3
			c-0.01,0-0.01,0-0.02,0l-1.97,0.35l-0.1,0.02c-0.52,0.1-0.98,0.18-1.43,0.26c-0.01,0-0.03,0-0.05,0L8.16,7.94c0,0,0,0,0,0
			c-0.61,0.11-1.13,0.2-1.65,0.29h0l-2.5,0.44L3.81,8.71z M26.87,12.59h-0.43c0.01,0.01,0.02,0.02,0.02,0.02c-0.64,0-1.18,0-1.72,0
			c-0.02,0-0.04-0.01-0.06-0.02h-1.9c0,0.01-0.01,0.02-0.02,0.03c-0.49,0-0.97,0.01-1.46-0.01c-0.04,0-0.07-0.01-0.11-0.02H19.2
			c0,0.01,0,0.01-0.01,0.02c-0.55,0-1.11,0-1.66,0c-0.01,0-0.03-0.01-0.04-0.01h-1.81c0.01,0.01,0.02,0.02,0.02,0.02
			c-0.65,0-1.19,0-1.72,0c-0.02,0-0.05-0.01-0.07-0.02h-1.84l0.03,0.03c-0.62,0-1.14,0.01-1.66,0c-0.03,0-0.06-0.01-0.09-0.02H8.49
			l0.03,0.03c-0.61,0-1.13,0-1.65-0.01c-0.03,0-0.06-0.01-0.09-0.02h-2.8v-2.51h22.89V12.59z"/>
            </g>
            <path class="st0" d="M18,20.27c-1.2-0.81-2.41-1.62-3.63-2.4c-0.19-0.12-0.54-0.17-0.72-0.07c-0.18,0.09-0.32,0.41-0.33,0.64
		c-0.04,0.8-0.02,1.61-0.02,2.42c0,0.82-0.02,1.64,0.02,2.46c0.01,0.22,0.16,0.53,0.34,0.63c0.16,0.1,0.51,0.05,0.68-0.06
		c1.23-0.79,2.45-1.6,3.66-2.42C18.52,21.11,18.51,20.62,18,20.27z M14.59,22.19v-2.65c0.67,0.44,1.3,0.86,2,1.33
		C15.9,21.32,15.27,21.74,14.59,22.19z"/>
            <path class="st0" d="M3.68,6.21L3.68,6.21z" />
            <path class="st1" d="M3.97,8.71l0.2-0.04c0.05-0.01,0.1-0.02,0.15-0.03" />
            <path class="st0" d="M15.16,14.75c-3.38,0-6.12,2.75-6.12,6.12s2.75,6.12,6.12,6.12c0.95,0,1.85-0.22,2.66-0.61
		c0.47-0.56,0.29-1.52-0.8-1.37c-0.57,0.26-1.19,0.4-1.86,0.4c-2.5,0-4.54-2.04-4.54-4.54s2.04-4.54,4.54-4.54s4.54,2.04,4.54,4.54
		c0,0.64-0.14,1.25-0.38,1.81c-0.21,0.58,0.42,1.32,1.3,0.95c0.42-0.83,0.66-1.77,0.66-2.76C21.28,17.49,18.54,14.75,15.16,14.75z"
            />
        </g>

    </Icon>
);

export default PCVideoIcon;
